if (!customElements.get('bike-hero-zoom')) {
  customElements.define('bike-hero-zoom', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.trigger = this.querySelector('button');
      this.dialog = document.createElement('dialog');
      if (typeof this.dialog.showModal !== 'function') return;
      this.dialog.className = 'bike-zoom-dialog';
      this.dialog.setAttribute('aria-label', 'Enlarged bike image');
      this.dialog.innerHTML = '<div class="bike-zoom-dialog__controls"><button type="button" data-zoom aria-pressed="false">Zoom in</button><button type="button" data-close autofocus>Close ×</button></div><div class="bike-zoom-dialog__viewport"><img class="bike-zoom-dialog__image" alt=""></div>';
      document.body.appendChild(this.dialog);
      this.trigger.hidden = false;
      const photo = this.dialog.querySelector('img');
      const zoom = this.dialog.querySelector('[data-zoom]');
      const viewport = this.dialog.querySelector('.bike-zoom-dialog__viewport');
      const toggleZoom = () => {
        const enlarged = this.dialog.dataset.zoomed !== 'true';
        this.dialog.dataset.zoomed = String(enlarged);
        zoom.textContent = enlarged ? 'Fit image' : 'Zoom in';
        zoom.setAttribute('aria-pressed', String(enlarged));
        viewport.scrollTo(0, 0);
      };
      this.open = () => {
        if (this.dialog.open || !window.matchMedia('(max-width:640px)').matches) return;
        photo.src = this.dataset.src;
        photo.alt = this.dataset.alt;
        this.dialog.dataset.zoomed = 'false';
        zoom.textContent = 'Zoom in';
        zoom.setAttribute('aria-pressed', 'false');
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.dialog.showModal();
        viewport.scrollTo(0, 0);
      };
      this.trigger.addEventListener('click', this.open);
      this.heroImage = this.parentElement.querySelector('img');
      if (this.heroImage) this.heroImage.addEventListener('click', this.open);
      zoom.addEventListener('click', toggleZoom);
      photo.addEventListener('click', toggleZoom);
      this.dialog.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow;
        this.trigger.focus({ preventScroll: true });
      });
    }
    disconnectedCallback() {
      if (this.heroImage) this.heroImage.removeEventListener('click', this.open);
      if (this.dialog) {
        if (this.dialog.open) this.dialog.close();
        this.dialog.remove();
      }
      this.initialised = false;
    }
  });
}
